import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import profileIcon from "src/assets/svg-icons/profile.svg";
import RightArrow from "src/assets/svg-icons/aggregators/right_arrow.svg";
import emailIcon from "src/assets/svg-icons/email.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { authState } from "src/store/auth";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import { useEffect, useRef, useState } from "react";
import LockDatePopup from "./lock-date-popup";
import moment from "moment";
import { oneBranchHasPermission } from "src/utils";
import { SettingsPermissions } from "src/constants/permissions";
import GovernmentTaxPopup from "./government-tax";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import {
  useConnectFoodicsCallback,
  useInitiateConnectToFoodics,
} from "src/api/profile";
import { notificationsState } from "src/store/notifications";
import SecondaryChip from "src/shared/components/secondary-chip";
import Terms from "./terms";
import StartBalanceDatePopup from "./start-balance-date-popup";

const MyProfile = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("profile");
  const { t: generalT } = useTranslation("general");
  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const [auth, setAuth] = useRecoilState(authState);
  const { user } = auth;
  const [open, setOpen] = useState(false);
  const [openFoodics, setOpenFoodics] = useState(false);
  const [openBalanceDate, setOpenBalanceDate] = useState(false);
  const [openGovTax, setOpenGovTax] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const [isLoading, setIsLoading] = useState(false);
  const calledRef = useRef(false);

  const initials = user?.name
    .split(" ")
    .map((word: string) => word.charAt(0))
    .join("");

  // apis
  const { data, refetch, isFetching, status, error } =
    useInitiateConnectToFoodics();
  const {
    mutate,
    isPending,
    error: callBackError,
    status: callBackStatus,
  } = useConnectFoodicsCallback();

  // permissions
  const editCompanyLockDatePermission = oneBranchHasPermission(
    SettingsPermissions.companyLockDate,
  );

  const navigateToDashboard = () => {
    navigate("/dashboard");
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenFoodics = () => setOpenFoodics(true);
  const handleCloseFoodics = () => setOpenFoodics(false);

  const handleOpenGovTax = () => setOpenGovTax(true);
  const handleCloseGovTax = () => setOpenGovTax(false);

  const handleConnectToFoodics = () => {
    setIsLoading(true);
    refetch();
  };

  useEffect(() => {
    if (!code || !state || calledRef.current) return;

    // calledRef.current = true;
    mutate({ code, state });
  }, [code, state]);

  //Connect to foodics success and error handling
  useEffect(() => {
    if (status === "success") {
      window.location.href = data?.data?.authorization_url;
      // handleClose();
    } else if (status === "error") {
      setIsLoading(false);
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors?.[0].value ?? generalT("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  //Callback success and error handling
  useEffect(() => {
    if (callBackStatus === "success") {
      setSearchParams();
      // window.location.reload();
      const newAuth = {
        ...auth,
        user: {
          ...user,
          company: {
            ...user.company,
            foodics_connected: true,
          },
        },
      };
      setAuth(newAuth);
    } else if (callBackStatus === "error") {
      setSearchParams();
      window.location.reload();
    }
  }, [callBackStatus]);

  console.log({ auth, user, callBackStatus, isPending });
  const handleOpenBalance = () => setOpenBalanceDate(true);
  const handleCloseBalance = () => setOpenBalanceDate(false);

  console.log({ auth, user });

  return (
    <Stack gap={3} p={{ xs: 2, sm: 3, md: "30px 200px" }}>
      <Stack direction={"row"} spacing={"12px"} alignItems={"center"}>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"60px"}
          height={"60px"}
          bgcolor={"#D0D5DD"}
          borderRadius={"16px"}
        >
          <img src={profileIcon} width={"32px"} alt="" />
        </Box>
        <Typography fontSize={"32px"} lineHeight={"38.4px"}>
          {t("myProfile")}
        </Typography>
      </Stack>

      <Stack spacing={2} direction={"row"} alignItems={"center"}>
        <Typography
          color={"#475467"}
          lineHeight={"19.2px"}
          onClick={navigateToDashboard}
          sx={{ cursor: "pointer" }}
        >
          {t("home")}
        </Typography>
        <img
          src={RightArrow}
          alt=""
          style={{
            transform: i18n.language === "en" ? "none" : "scaleX(-1)",
          }}
        />
        <Box borderRadius={"4px"} bgcolor={"#EAECF0"} p={"4px 8px"}>
          <Typography color={"#344054"} fontWeight={600} lineHeight={"19.2px"}>
            {t("profile")}
          </Typography>
        </Box>
      </Stack>
      {/* divider */}
      <Box bgcolor={"#F2F4F7"} width={"100%"} height={"1px"} />
      {isPending ? (
        <Box display={"flex"} justifyContent={"center"} pt={13}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Stack
            direction={{ xs: "column", lg: "row" }}
            spacing={3}
            bgcolor={"#F9FAFB"}
            borderRadius={"8px 8px 0px 0px"}
            p={2}
          >
            <Avatar
              sx={{ borderRadius: 1, width: "140px", height: "140px" }}
              variant="square"
            >
              {/* <Typography textTransform={"uppercase"}>{initials}</Typography> */}
            </Avatar>
            <Box>
              <Typography
                fontSize={"23px"}
                fontWeight={600}
                lineHeight={"27.6px"}
              >
                {user.name}
              </Typography>
              <Stack direction={"row"} spacing={1}>
                <img src={emailIcon} width={"20px"} alt="" />

                <Typography
                  fontSize={"16px"}
                  color={"#98A2B3"}
                  lineHeight={"19.2px"}
                >
                  {user.email}
                </Typography>
              </Stack>
            </Box>
          </Stack>
          <Stack
            borderRadius={"0px 0px 8px 8px"}
            border={"1px solid #EAECF0"}
            bgcolor={"#FFF"}
            p={3}
            spacing={"12px"}
          >
            <Typography
              align="center"
              fontSize={"16px"}
              color={"#475467"}
              lineHeight={"19.2px"}
            >
              {t("profileDetails")}
            </Typography>
            {/* divider */}
            <Box bgcolor={"#EAECF0"} width={"100%"} height={"1px"} />

            <Grid container bgcolor={"#F9FAFB"} p={2} spacing={2}>
              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {t("fullName")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography
                  fontSize={{ xs: "12 !important", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#101828"}
                >
                  {user.name}
                </Typography>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {t("email")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                {editCompanyLockDatePermission ? (
                  <IconButton sx={{ p: "0" }} onClick={handleOpen}>
                    <img src={EditIcon} alt="" />
                  </IconButton>
                ) : null}
              </Grid>
            </Grid>

            {/* start balance date */}
            <Grid item xs={4} sm={2}>
              <Typography
                fontSize={{ xs: "12", lg: "16px" }}
                fontWeight={600}
                lineHeight={"19.2px "}
                color={"#344054"}
              >
                {generalT("startBalanceDate")}
              </Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Stack direction={"row"} gap={1} alignItems={"center"}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px"}
                  color={"#101828"}
                >
                  {user.company?.start_balance_date
                    ? moment(user.company?.start_balance_date)?.format(
                        "DD/MM/YYYY",
                      )
                    : "--"}
                </Typography>
                <IconButton sx={{ p: "0" }} onClick={handleOpenBalance}>
                  <img src={EditIcon} alt="" />
                </IconButton>
              </Stack>
            </Grid>

            <Grid item xs={4} sm={2}>
              <Typography
                fontSize={{ xs: "12", lg: "16px" }}
                fontWeight={600}
                lineHeight={"19.2px "}
                color={"#344054"}
              >
                {t("governmentStartBalanceTax")}
              </Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Grid direction={"row"} gap={1} alignItems={"center"}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#101828"}
                >
                  {user.email}
                </Typography>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {t("company")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#101828"}
                >
                  {user.company.name}
                </Typography>
              </Grid>

              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {t("companyId")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#101828"}
                >
                  {user.company.reference_number}
                </Typography>
              </Grid>

              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {t("foodicsCompanyId")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                  <Typography
                    fontSize={{ xs: "12", lg: "16px" }}
                    fontWeight={600}
                    lineHeight={"19.2px"}
                    color={"#101828"}
                  >
                    {user.company?.foodics_reference}
                  </Typography>
                  {user.company?.foodics_connected ? (
                    <SecondaryChip variant="success" label={t("connected")} />
                  ) : (
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleOpenFoodics}
                    >
                      {t("connectToFoodics")}
                    </Button>
                  )}
                </Stack>
              </Grid>

              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {generalT("lockDate")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                  <Typography
                    fontSize={{ xs: "12", lg: "16px" }}
                    fontWeight={600}
                    lineHeight={"19.2px"}
                    color={"#101828"}
                  >
                    {moment(user.company?.close_date)?.format("DD/MM/YYYY")}
                  </Typography>
                  {editCompanyLockDatePermission ? (
                    <IconButton sx={{ p: "0" }} onClick={handleOpen}>
                      <img src={EditIcon} alt="" />
                    </IconButton>
                  ) : null}
                </Stack>
              </Grid>

              <Grid item xs={4} sm={2}>
                <Typography
                  fontSize={{ xs: "12", lg: "16px" }}
                  fontWeight={600}
                  lineHeight={"19.2px "}
                  color={"#344054"}
                >
                  {t("governmentStartBalanceTax")}
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                  <Typography
                    fontSize={{ xs: "12", lg: "16px" }}
                    fontWeight={600}
                    lineHeight={"19.2px"}
                    color={"#101828"}
                  >
                    {user.company?.government_tax}
                  </Typography>
                  {editCompanyLockDatePermission ? (
                    <IconButton sx={{ p: "0" }} onClick={handleOpenGovTax}>
                      <img src={EditIcon} alt="" />
                    </IconButton>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>
            <Terms />
          </Stack>
        </Box>
      )}

      {open && <LockDatePopup open={open} handleClose={handleClose} />}

      {openGovTax && (
        <GovernmentTaxPopup open={openGovTax} handleClose={handleCloseGovTax} />
      )}

      {openBalanceDate && (
        <StartBalanceDatePopup
          open={openBalanceDate}
          handleClose={handleCloseBalance}
        />
      )}

      {openGovTax && (
        <GovernmentTaxPopup open={openGovTax} handleClose={handleCloseGovTax} />
      )}

      <ConfirmPopup
        open={openFoodics}
        handleClose={handleCloseFoodics}
        handleConfirm={handleConnectToFoodics}
        title={" "}
        subtitle={t("sureToConnectToFoodics")}
        confirmBtnText={generalT("confirm")}
        noIcon
        confirmBtnColor={"primary"}
        isPending={isLoading}
      />
    </Stack>
  );
};

export default MyProfile;
